import { forwardRef, type TextareaHTMLAttributes } from 'react';

/*
 * Textarea — multi-line counterpart to <Input>. Matches Input padding,
 * radius, border, typography. State extensions mirror Input (focus border
 * shift, aria-invalid error border, disabled opacity).
 *
 * The component does not accept a `className` prop. To change size or
 * tone, extend the variant table here.
 */
export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(props, ref) {
    return (
      <textarea
        ref={ref}
        className={
          'flex min-h-textarea w-full resize-y rounded-md border border-input bg-card px-3 py-2 text-meta text-foreground ' +
          'placeholder:text-faint-foreground outline-none ' +
          'transition-[border-color,box-shadow] duration-base ease-standard ' +
          'focus:border-primary focus:shadow-ring-primary-lg ' +
          'disabled:cursor-not-allowed disabled:bg-accent disabled:text-muted-foreground ' +
          'read-only:cursor-not-allowed read-only:bg-accent read-only:text-muted-foreground ' +
          'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus:shadow-ring-destructive'
        }
        {...props}
      />
    );
  },
);
